import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../../context/AdminAuth';

const API_URL = 'https://nwt.am';
export default function AdminLogin() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { login } = useAdminAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
        const res = await fetch(`${API_URL}/login.php`, {  // ← /login.php, не /auth/login
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ username, password })
        });
        
        const data = await res.json();
        
        if (res.ok) {
            login(data.token);
            navigate('/admin');
        } else {
            setError(data.error || 'Սխալ մուտքանուն կամ գաղտնաբառ');
        }
    } catch (err) {
        setError('Միացման սխալ');
    } finally {
        setLoading(false);
    }
};
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100">
            <div className="bg-white p-8 shadow-lg w-full max-w-md">
                <h1 className="text-2xl font-black text-[#0B3B6F] uppercase mb-6 text-center">
                    NWTA Admin
                </h1>
                
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-xs font-bold text-[#0B3B6F] uppercase mb-1.5">
                            Մուտքանուն
                        </label>
                        <input
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            className="w-full border border-gray-300 px-4 py-3 text-sm focus:outline-none focus:border-[#0FA4E8]"
                            placeholder="admin"
                            required
                        />
                    </div>
                    
                    <div>
                        <label className="block text-xs font-bold text-[#0B3B6F] uppercase mb-1.5">
                            Գաղտնաբառ
                        </label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full border border-gray-300 px-4 py-3 text-sm focus:outline-none focus:border-[#0FA4E8]"
                            placeholder="••••••••"
                            required
                        />
                    </div>
                    
                    {error && (
                        <p className="text-red-500 text-sm text-center">{error}</p>
                    )}
                    
                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full bg-[#0FA4E8] hover:bg-[#0B3B6F] text-white font-bold py-3 uppercase tracking-wider text-sm transition-colors"
                    >
                        {loading ? 'Մուտք...' : 'Մուտք'}
                    </button>
                </form>
            </div>
        </div>
    );
}